import { combineReducers } from 'redux';
// slices
import userReducer from './slices/user';
import pathwayReducer from '../pages/pathways-page/slice';
import sharedPathwayReducer from '../pages/explore-pathway-shared-page/slice';
import topicSuggestionReducer from '../features/@topic-suggestion/slice';
import builderReducer from '../features/pathway-builder/slice';
import exploreReducer from '../pages/explore-pathways-page/slice';
import invitationReducer from '../features/invitation/slice';
import followingReducer from '../pages/explore-pathway-following-page/slice';
import exploreDetailsReducer from '../pages/explore-pathway-view-page/slice';
import pathwayFollowingViewerReducer from '../pages/explore-pathway-following-viewer-page/slice';
import pathwaySharedViewerReducer from '../pages/explore-pathway-shared-viewer-page/slice';
import personalLearningReducer from '../pages/personal-learning-page/slice';
import createReducer from '../pages/pathway-create-page/slice';
import suggestionsReducer from '../pages/suggestions-page/slice';
import circleReducer from '../pages/circles-page/slice';
import circleActivityReducer from '../pages/circle-activity-page/slice';
import circleCreateReducer from '../pages/circle-create-page/slice';
import circleDetailsReducer from '../pages/circle-details-page/slice';
import aiChatReducer from '../features/ai-chat/slice';
import upNextReducer from '../pages/up-next-page/slice';
import externalPlatformsReducer from '../pages/external-platforms-page/slice';
import adminReducer from '../_admin-pages/slice';
import tiptapToolbarReducer from '../components/editor/tiptap/slice';
import personalGraphReducer from '../features/personal-graph/slice';
import topicEditReducer from '../pages/topic-edit-single-page/slice';
import flashcardReviewReducer from '../pages/flashcard-review-page/slice';

const rootReducer = combineReducers({
  user: userReducer,
  pathway: pathwayReducer,
  sharedPathways: sharedPathwayReducer,
  builder: builderReducer,
  topicSuggestion: topicSuggestionReducer,
  explore: exploreReducer,
  invitation: invitationReducer,
  following: followingReducer,
  exploreDetails: exploreDetailsReducer,
  pathwayFollowingViewer: pathwayFollowingViewerReducer,
  pathwaySharedViewer: pathwaySharedViewerReducer,
  personalLearning: personalLearningReducer,
  create: createReducer,
  suggestions: suggestionsReducer,
  circle: circleReducer,
  circleActivity: circleActivityReducer,
  circleCreate: circleCreateReducer,
  circleDetails: circleDetailsReducer,
  aiChat: aiChatReducer,
  upNext: upNextReducer,
  externalPlatforms: externalPlatformsReducer,
  admin: adminReducer,
  tiptapToolbar: tiptapToolbarReducer,
  personalGraph: personalGraphReducer,
  topicEdit: topicEditReducer,
  flashcardReview: flashcardReviewReducer
});

export { rootReducer };
